import {
	notApplicableClickedElement,
	type MessageInstanceClickedParams,
} from '@atlassian/post-office-context/message-instance-event-client';

export type MessageReadStateAction = 'read' | 'unread';

const interactionIdentifierByAction: Record<MessageReadStateAction, string> = {
	read: 'mark-as-read',
	unread: 'mark-as-unread',
};

/**
 * Maps a notification read-state operation to the validated message-instance event shape.
 *
 * Read state is not a semantic response to a message, so its clicked element is always the
 * Post Office-owned `not-applicable` value. The stable identifier is mirrored into the clicked
 * element because runtime validation requires those fields to match.
 */
export const mapMessageReadStateActionToClickedEvent = (
	actionType: MessageReadStateAction,
): MessageInstanceClickedParams => {
	const interactionIdentifier = interactionIdentifierByAction[actionType];

	return {
		messageEventType: 'clicked',
		interactionIdentifier,
		clickedElement: notApplicableClickedElement(interactionIdentifier),
		action: { actionType },
	};
};
